import {
  Dialog,
  Box,
  Grid,
  IconButton,
  Typography,
  Button,
  DialogContent,
  DialogActions,
  DialogContentText,
  Autocomplete,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  FormHelperText
} from "@mui/material";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React, { useEffect, useState, useMemo } from "react";
import Notify from "../../Notify";
import { getData, postData, putData } from "../../../services/library";
import { logEventos } from "../../../services/services";
import { v4 as uuidv4 } from 'uuid';   ///me da un unico id para poner en los pedidos y repartos
import moment from "moment";
import UpdatedUploadFiles from "../../../services/UpdatedUploadFiles";
import { UrlApi } from "../../../services/apirest";

export default function ConfirmarGrua(props) {
  const { datos, newUuid, open, setOpen, tabla, actualizar } = props;
  const [openCloseAdj, setOpenCloseAdj] = useState(false);
  const [gruas, setgruas] = useState([]);
  const [gruaSeleccionada, setgruaSeleccionada] = useState("");
  const [tanques, setTanques] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [viajeExiste, setviajeExiste] = useState(false);
  const [viaje, setViaje] = useState([]);
  const [instaladores, setInstaladores] = useState([]);
  const [uniqueInstalador, setUniqueInstalador] = useState("");
  const [fechaSalida, setfechaSalida] = useState(null);
  const isTanqueMedio = tanques?.some((t) => t.capacidad === 0.5);
  let uuid = uuidv4();

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const obtenerInstaladores = () => {
    fetch(UrlApi + "/proveedores/instaladores/")
      .then((data) => data.json())
      .then((data) => setInstaladores(data));
  };

  const getGruas = () => {
    getData('/vehiculos/seguntipo/13', setgruas)
  };

  useEffect(() => {
    getGruas();
    obtenerInstaladores()
  }, []);

  const gruaPorDefecto = useMemo(() => {
    if (!gruas || !datos?.id_sucursal) return null;

    return gruas.find(g => {
      if (!g.suc_auth) return false;

      const autorizadas = g.suc_auth
        .split(",")
        .map(n => Number(n.trim()));

      return autorizadas.includes(Number(datos.id_sucursal));
    }) || null;
  }, [gruas, datos.id_sucursal]);

  useEffect(() => {
    if (!gruaSeleccionada && gruaPorDefecto) {
      setgruaSeleccionada(gruaPorDefecto.id);
    }
  }, [gruaPorDefecto]);

  const obtenerTanque = () => {
    const uuidTanques = datos.uuid_tanques || null;
    const uuid = datos.uuid || null;

    fetch(`${UrlApi}/reclamos/a/detalleTanques2/${uuidTanques}/${uuid}`)
      .then((res) => res.json())
      .then((data) => {
        setTanques(data);
      })
      .catch((err) => console.error("Error obteniendo tanque:", err));
  };

  useEffect(() => {
    obtenerTanque();
  }, []);

  useEffect(() => {
    const obtenerViaje = async () => {
      await fetch(`${UrlApi}/viajes_gruas/por_vehiculo/${gruaSeleccionada}/${fechaSalida}`)
        .then(res => {
          if (res.ok) {
            return res.json();
          } else {
            console.log("Error obteniendo datos");
          }
        }).then(data => {
          data && setViaje(data)
          data && setviajeExiste(Object.keys(data).length > 0 ? true : false)
        })
    };

    datos.id_motivo === 41 && gruaSeleccionada && isTanqueMedio && fechaSalida &&
      obtenerViaje()

  }, [gruaSeleccionada && fechaSalida, viajeExiste]);

  const handleUpdateReclamos = async (e) => {
    logEventos(
      `Elección de grua ${gruaSeleccionada} para reclamo ${datos.id_reclamo}`,
      "Reclamos Granel",
      "Se guardó la grua",
      localStorage.getItem('user')
    );

    const requiereViaje = datos.id_motivo === 41 && isTanqueMedio;

    await putData(
      e,
      `/reclamos/update/${datos.id_reclamo}`,
      {
        estado: requiereViaje ? 348 : 346,
        usuario: localStorage.getItem('user'),
        id_proveedor: uniqueInstalador.id,
        uuid_viaje: requiereViaje ? uuid : null,
      },
      setNotificacion
    );

    if (requiereViaje) {
      await crearViaje(e);
    }

    handleClose();
  };


  const crearViaje = async (e) => {
    await postData(e,
      '/viajes_gruas',
      {
        id_grua: gruaSeleccionada,
        estado: 343,
        fecha_inicio: today,
        usuario: localStorage.getItem('user'),
        fecha_programada_viaje: fechaSalida,
        uuid_viaje: uuid
      },
      setNotificacion
    );
  }

  const handleClose = () => {
    tabla(true);
    setOpen(false);
    actualizar();
  };

  const handleCloseAdj = () => {
    setOpenCloseAdj(false);
    actualizar();
  };


  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true} maxWidth="md">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container backgroundColor="#1F618D" p={1.5}>
          <Grid item xs={2}>
            <IconButton
              onClick={() => setOpen(false)}
              sx={{ color: "#fff" }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Grid>
          <Grid
            item
            xs={8}
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Typography variant="h5" color="#ffffff">
              {datos.id_motivo === 41 && isTanqueMedio ? "Coordinar viaje de tanque" : "Confirmar Grúa"}
            </Typography>
          </Grid>
          <Grid item xs={2}>

          </Grid>
        </Grid>
      </Box>
      <DialogContent>
        <DialogContentText textAlign="center">
          {isTanqueMedio && datos.id_motivo === 41 ? "Seleccioná la grúa, proveedor y la fecha de salida del viaje" : "El reclamo ha sido confirmado y se encuentra disponible para asignación de viaje."}

          {viajeExiste &&
            <Typography color="error">
              Ya existe un viaje  programado para la grua seleccionada y fecha de salida.
            </Typography>}
        </DialogContentText>



        <Grid container spacing={3} mt={1}>
          {/* Selección de grúa */}
          <Grid item xs={2}></Grid>
         
          <Grid item xs={2}></Grid>
          {/* Bloque condicional */}
          {isTanqueMedio && datos.id_motivo === 41 && (
            <>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                   <Grid item xs={8}>
            <FormControl fullWidth focused size="small">
              <InputLabel>Grúa</InputLabel>
              <Select
                label="Grúa"
                value={gruaSeleccionada}
                onChange={(e) => setgruaSeleccionada(e.target.value)}
              >
                {gruas?.map((g) => (
                  <MenuItem key={g.id} value={g.id}>
                    {g.patente}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
                  <Grid item xs={12} md={8}>
                    <Autocomplete
                      options={instaladores || []}
                      autoHighlight

                      disableClearable
                      noOptionsText="Instalador inexistente"
                      getOptionLabel={(inst) => inst.razon_social}
                      onChange={(e, value) => setUniqueInstalador(value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Instalador"
                          placeholder="Buscar instalador…"
                          required
                          focused
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      label="Fecha de salida"
                      focused
                      type="date"
                      name="fecha_salida"
                      value={fechaSalida ? fechaSalida : ""}
                      onChange={(e) => setfechaSalida(e.target.value)}
                      inputProps={{ min: today }}
                      fullWidth
                      required
                    />
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          // disabled={!gruaSeleccionada || (datos.id_motivo !== 19 && !datos.total_archivos)}
          variant="contained"
          color="success"
          onClick={handleUpdateReclamos}
          disabled={viajeExiste}
        >
          Confirmar
        </Button>

      </DialogActions>


      {
        notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={handleClose}
            severity={notificacion.severity}
          />
        ) : null
      }

      {openCloseAdj ? ( // ADJUNTAR COMPROBANTES
        <UpdatedUploadFiles
          fileId={datos.uuid}
          open={openCloseAdj}
          setOpen={handleCloseAdj}
          title={"Adjuntar archivos"} />
      ) : null}
    </Dialog>
  )

}

